import React, { Component } from "react";
import * as pr from "../../common/PrimeComponents";
import * as Log from "../../common/Feedback/Log";
import * as format from "../../common/FormatFunctions";
import * as Constant from "../../common/config/Configuration";

export class FileUploader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: null,
      errors: []
    };

    this.logger = Log;
    this.logger.info(this.props.currentFiles);
  }

  onUploadImage = (files, onlyOne) => {
    const ref = Constant.getFirebaseStorage();
    this.logger.info(Object.values(files));
    const fileArray = Object.values(files);

    fileArray.forEach(e => {
      const name =
        format.formatDate(new Date(), "YYYYMMDDHHMMSS") + "-" + e.name;
      const metadata = {
        contentType: e.type,
        visibilty: "public"
      };

      const task = ref.child(name).put(e, metadata);
      task
        .then(snapshot => snapshot.ref.getDownloadURL())
        .then(url => {
          this.logger.info(url);
          var localList = format.deepCopy(this.props.currentFiles);
          if (!format.isNotNull(localList)) {
            localList = [];
          }
          if (this.props.fileType === "IMAGE") {
            if (onlyOne) {
              localList = [];
            }
            localList.push(url);

            this.logger.info(localList);
            this.props.updateFiles(this.props.field, localList);
          }
          if (this.props.fileType === "FILE") {
            localList.push(JSON.stringify({ url: url, name: name }));

            this.props.updateFiles(this.props.field, localList);
          }
        });
    });
  };

  removeImage = (f, imageUri) => {
    f.preventDefault();
    this.logger.info(imageUri);
    var localImageUri = format.deepCopy(this.props.currentFiles);
    localImageUri = localImageUri.filter(element => element !== imageUri);

    this.props.updateFiles(this.props.field, localImageUri);
  };

  removeFile = (f, imageUri) => {
    f.preventDefault();
    this.logger.info(imageUri);
    var localImageUri = format.deepCopy(this.props.currentFiles);
    localImageUri = localImageUri.filter(element => element !== imageUri);

    this.props.updateFiles(this.props.field, localImageUri);
  };

  render() {
    return (
      <React.Fragment>
        {this.props.fileType === "IMAGE" && !this.props.limited && (
          <React.Fragment>{this.getImagesToDisplay()}</React.Fragment>
        )}
        {this.props.fileType === "IMAGE" && this.props.limited && (
          <React.Fragment>{this.getImageSingleToDisplay()}</React.Fragment>
        )}
        {this.props.fileType === "FILE" && (
          <React.Fragment>{this.getUrlsToDisplay()}</React.Fragment>
        )}
      </React.Fragment>
    );
  }

  getImagesToDisplay = () => {
    return (
      <pr.DataTable
        ref={el => {
          this.dt = el;
        }}
        reorderableColumns={false}
        selectionMode="single"
        onSelectionChange={e => {}}
        value={this.props.currentFiles}
        dataKey="id"
        emptyMessage="No Images"
        rows={100}
        autoLayout={true}
      >
        <pr.Column
          body={this.imageValueTemplate}
          style={{ overflow: "auto", background: "white" }}
        />
        <pr.Column
          header={
            <pr.FileUpload
              style={
                this.props.currentFiles
                  ? { display: "none" }
                  : { float: "right" }
              }
              mode="basic"
              auto={true}
              customUpload={true}
              accept={this.props.accept}
              chooseLabel={this.props.label}
              onSelect={e => {
                this.onUploadImage(e.files);
              }}
            ></pr.FileUpload>
          }
          key="add"
          body={this.getImagePropertyRemoveTemplate}
          style={{ textAlign: "center", background: "white", width: "8em" }}
        />
      </pr.DataTable>
    );
  };

  getImageSingleToDisplay = () => {
    var image = "";
    if (format.isNotNull(this.props.currentFiles)) {
      if (format.isNotNull(this.props.currentFiles[0])) {
        image = this.props.currentFiles[0];
      }
    }

    return (
      <React.Fragment>
        <div
          style={{
            width: "75%",
            objectFit: "contain",
            height: "200px",
            marginTop: "18px",
            border: "1px solid lightgrey",
            borderRadius: "25px"
          }}
        >
          <img
            src={image}
            alt={image}
            style={{
              width: "100%",
              height: "200px"
            }}
            onClick={() => {
              window.open(image);
            }}
          />
        </div>
        <pr.FileUpload
          style={
            this.props.currentFiles ? { display: "none" } : { float: "right" }
          }
          mode="basic"
          auto={true}
          customUpload={true}
          accept={this.props.accept}
          chooseLabel={this.props.label}
          onSelect={e => {
            this.onUploadImage(e.files, true);
          }}
        ></pr.FileUpload>
      </React.Fragment>
    );
  };
  getImagePropertyRemoveTemplate = (rowData, column) => {
    return (
      <div>
        <pr.Button
          align="right"
          icon="pi pi-times"
          className="p-button-danger"
          style={{ float: "middle", background: "red" }}
          onClick={f => {
            this.removeImage(f, rowData);
          }}
        />
      </div>
    );
  };

  imageValueTemplate = (rowData, column) => {
    return (
      <img
        src={rowData}
        alt={rowData}
        style={{
          width: "100%",
          objectFit: "contain",
          height: "300px",
          marginTop: "18px",
          border: "1px solid lightgrey",
          borderRadius: "25px"
        }}
        onClick={() => {
          window.open(rowData);
        }}
      />
    );
  };

  getUrlsToDisplay = () => {
    return (
      <div className="ui-g-12" style={{ paddingTop: "2em" }}>
        <pr.DataTable
          ref={el => {
            this.dt = el;
          }}
          reorderableColumns={false}
          selectionMode="single"
          onSelectionChange={e => {}}
          value={this.props.currentFiles}
          dataKey="id"
          emptyMessage={this.props.emptyTableDisplay || "No Files"}
          rows={100}
          autoLayout={true}
        >
          <pr.Column
            header={this.props.header || "Files"}
            body={this.urlValueTemplate}
            style={{ overflow: "auto", background: "white" }}
          />
          <pr.Column
            header={
              <pr.FileUpload
                style={{ float: "right" }}
                mode="basic"
                auto={true}
                customUpload={true}
                accept={this.props.accept}
                chooseLabel={this.props.label}
                onSelect={e => {
                  this.onUploadImage(e.files);
                }}
              ></pr.FileUpload>
            }
            key="add"
            body={this.getUrlPropertyRemoveTemplate}
            style={{ textAlign: "center", background: "white", width: "8em" }}
          />
        </pr.DataTable>{" "}
      </div>
    );
  };
  getUrlPropertyRemoveTemplate = (rowData, column) => {
    return (
      <div>
        <pr.Button
          align="right"
          icon="pi pi-times"
          className="p-button-danger"
          style={{ float: "middle", background: "red" }}
          onClick={f => {
            this.removeFile(f, rowData);
          }}
        />
      </div>
    );
  };

  urlValueTemplate = (rowData, column) => {
    var parseRowData = JSON.parse(rowData);
    this.logger.info(parseRowData);
    return (
      <label
        onClick={() => {
          window.open(parseRowData.url);
        }}
      >
        {parseRowData.name}
      </label>
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/Common/FileUploader.js